import React from 'react';

type ToggleSwitchProps = {
  onChange: (e: any) => void;
  value: boolean;
  readOnly?: boolean;
  htmlId?: string;
  disable?: boolean;
};

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ 
    onChange, 
    value, 
    readOnly, 
    htmlId,
    disable
}) => {
    return (
        <label className={"ToggleSwitch" + (disable ? " Disable" : "")}>
            <input
                type="checkbox"
                onChange={onChange}
                checked={value}
                readOnly={readOnly}
                disabled={readOnly}
                id={htmlId}
            />
            <span></span>
        </label>
    );
};

export default ToggleSwitch;
